/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Breadcrumbs } from '@uhg-abyss/web/ui/Breadcrumbs';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import {
  CommunityConnectorMode,
  getModeFromStorage,
} from '@src/utills/storage';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { memberInContextAtom } from '@src/global-state';
import { useAtomValue } from 'jotai';
import { trimZipcodeToFiveDigits } from '@repo/utils';

export enum ScreenConstants {
  MEMBER_PROFILE = 'MEMBER_PROFILE',
  CBO_SEARCH = 'CBO_SEARCH',
  BENEFIT_PAGE = 'BENEFIT_PAGE',
  SDOH_SCREENER = 'SDOH_SCREENER',
  BENEFIT_DETAILS = 'BENEFIT_DETAILS',
  BENEFIT_DETAILS_WITH_SEARCH = 'BENEFIT_DETAILS_WITH_SEARCH',
  BENEFIT_SEARCH_RESULTS = 'BENEFIT_SEARCH_RESULTS',
  NEED_ASSEMENT = 'NEED_ASSEMENT',
  CBO_DETAIL_PAGE = 'CBO_DETAIL_PAGE',
  MY_FAVORITES = 'MY_FAVORITES',
}

export const Breadcumbs = (props) => {
  const { getSearchParams } = useRouter();
  const [searchParams] = getSearchParams();
  const memberInContext = useAtomValue(memberInContextAtom);
  const [items, setItems] = useState<any[]>([]);
  const mode: CommunityConnectorMode = getModeFromStorage();
  const currentParams = Object.fromEntries([...searchParams]);
  const [zipcode, setZipCode] = useState<string>(() => {
    return trimZipcodeToFiveDigits(
      currentParams.zipcode ?? memberInContext?.zipCode ?? ''
    );
  });
  const [showMemberSearchBreadcrum, setShowMemberSearchBreadcrum] =
    useState(true);

  const [showBreadcrum, setShowBreadcrum] = useState(true);

  let fromSearch = sessionStorage.getItem('fromSearch') || 'false';

  useEffect(() => {
    if (sessionStorage.getItem('fromSearch') !== null)
      setShowBreadcrum(JSON.parse(fromSearch?.toLowerCase()));
  }, []);
  function checkThirdPartyAccess() {
    if (
      mode !== '' &&
      (mode === 'maestro' ||
        mode === 'ICM' ||
        mode === 'maestroMedicare' ||
        mode === 'MedSup' ||
        mode === 'communityCare' ||
        mode === 'ICUE' ||
        mode === 'maestroIFP' ||
        mode === 'ACETEANDI' ||
        mode === 'ISETEANDI' ||
        mode === 'ACET')
    ) {
      setShowMemberSearchBreadcrum(false);
    }
  }
  useEffect(() => {
    checkThirdPartyAccess();
  }, [mode]);

  useEffect(() => {
    // eslint-disable-next-line default-case
    switch (props.screen) {
      case ScreenConstants.MEMBER_PROFILE:
        setItems(
          [
            showMemberSearchBreadcrum && {
              title: 'Member Search',
              href: '/home',
            },
            {
              title: 'Member Profile',
              href: '/',
            },
          ].filter(Boolean)
        );
        break;
      case ScreenConstants.CBO_SEARCH:
        setItems(
          [
            showMemberSearchBreadcrum && {
              title: 'Member Search',
              href: '/home',
            },
            { title: 'Member Profile', href: '/' },
            { title: 'CBO Search', href: '/' },
          ].filter(Boolean)
        );
        break;

      case ScreenConstants.BENEFIT_PAGE:
        setItems(
          [
            showMemberSearchBreadcrum && {
              title: 'Member Search',
              href: '/home',
            },
            { title: 'Member Profile', href: '/memberprofile' },
            showBreadcrum && {
              title: 'CBO Search',
              href: `/search?zipcode=${zipcode}`,
            },
            { title: 'Plan Benefits', href: '/' },
          ].filter(Boolean)
        );
        break;
      case ScreenConstants.BENEFIT_DETAILS:
        setItems(
          [
            showMemberSearchBreadcrum && {
              title: 'Member Search',
              href: '/home',
            },
            { title: 'Member Profile', href: '/memberprofile' },

            { title: 'Plan Benefits', href: '/planbenefits' },
            { title: 'Benefit Details', href: '/' },
          ].filter(Boolean)
        );
        break;
      case ScreenConstants.BENEFIT_DETAILS_WITH_SEARCH:
        setItems(
          [
            showMemberSearchBreadcrum && {
              title: 'Member Search',
              href: '/home',
            },
            { title: 'Member Profile', href: '/memberprofile' },
            { title: 'CBO Search', href: `/search?zipcode=${zipcode}` },
            { title: 'Plan Benefits', href: '/planbenefits' },
            { title: 'Benefit Details', href: '/' },
          ].filter(Boolean)
        );
        break;
      case ScreenConstants.SDOH_SCREENER:
        setItems(
          [
            showMemberSearchBreadcrum && {
              title: 'Member Search',
              href: '/home',
            },
            {
              title: 'Member Profile',
              href: '/memberprofile',
            },
            { title: 'SDOH Screener', href: '/' },
          ].filter(Boolean)
        );
        break;
      case ScreenConstants.BENEFIT_SEARCH_RESULTS:
        setItems(
          [
            showMemberSearchBreadcrum && {
              title: 'Member Search',
              href: '/home',
            },
            { title: 'Member Profile', href: '/memberprofile' },
            showBreadcrum && {
              title: 'CBO Search',
              href: `/search?zipcode=${zipcode}`,
            },
            { title: 'Plan Benefits', href: '/planbenefits' },
            { title: 'Benefit Search Results', href: '/' },
          ].filter(Boolean)
        );
        break;
      case ScreenConstants.CBO_DETAIL_PAGE:
        setItems(
          [
            showMemberSearchBreadcrum && {
              title: 'Member Search',
              href: '/home',
            },
            { title: 'Member Profile', href: '/memberprofile' },
            {
              title: 'CBO Search',
              href: `/search?zipcode=${trimZipcodeToFiveDigits(
                memberInContext?.addrZipCode ?? ''
              )}`,
            },
            { title: 'CBO Detail' },
          ].filter(Boolean)
        );
        break;
      case ScreenConstants.MY_FAVORITES:
        setItems(
          [
            showMemberSearchBreadcrum && {
              title: 'Member Search',
              href: '/home',
            },
            { title: 'Member Profile', href: '/memberprofile' },
            {
              title: 'CBO Search',
              href: `/search?zipcode=${trimZipcodeToFiveDigits(
                memberInContext?.addrZipCode ?? ''
              )}`,
            },
            { title: 'My Favorites' },
          ].filter(Boolean)
        );
        break;
    }
  }, [props, showMemberSearchBreadcrum]);
  return (
    <div className="sdoh-breadcrumbs-wrapper" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <style>{`
        .sdoh-breadcrumbs-wrapper a,
        .sdoh-breadcrumbs-wrapper li span { font-size: 18px !important; }
        .sdoh-breadcrumbs-wrapper .abyss-breadcrumb-current { font-weight: bold; }
      `}</style>
      <IconSymbol icon="home" size='$web.semantic.sizing.icon.utility.md' color="black"/>
      <Breadcrumbs items={items} />
    </div>
  );
};
